import { useQuery, type QueryClient } from '@tanstack/react-query';
import {
  apiBoostersGetCollection,
  getApiBoostersGetCollectionQueryKey
} from '@r/api/generated/client.ts';
import type { BoosterBoosterCollectionReadModel } from '@r/api/generated/client.schemas.ts';
import { getBoostersFromResponse, getBoostersPaginationFromResponse } from './booster-utils.ts';

const BOOSTERS_ALL_PAGES_QUERY_KEY = [
  ...getApiBoostersGetCollectionQueryKey(),
  'all-pages'
] as const;

/** Charge l'intégralité de la collection boosters (pagination API agrégée). */
export function useBoostersCollection() {
  return useQuery({
    queryKey: BOOSTERS_ALL_PAGES_QUERY_KEY,
    queryFn: async (): Promise<BoosterBoosterCollectionReadModel[]> => {
      const perPage = 30;
      let page = 1;
      let lastPage = 1;
      const boosters: BoosterBoosterCollectionReadModel[] = [];

      do {
        const response = await apiBoostersGetCollection({ page, perPage });
        boosters.push(...getBoostersFromResponse(response));
        lastPage = getBoostersPaginationFromResponse(response)?.last ?? 1;
        page += 1;
      } while (page <= lastPage);

      return boosters;
    },
    placeholderData: (previousData) => previousData
  });
}

/** Invalide la liste des boosters après création / édition / suppression. */
export function invalidateBoostersListQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: BOOSTERS_ALL_PAGES_QUERY_KEY });
}
